class SettingsController {
  constructor() {}

}

angular.module('pims').controller('SettingsController', SettingsController);
